import CustomerStorySmallCard from "@components/BasicComponents/Cards/CustomerStory/CustomerStorySmallCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {useLocale} from "@components/Contexts/LocaleContext"
import Asset from "@components/CustomTypography/Asset/Asset"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {getPosts} from "@config/modules"
import {translate} from "@helpers/translate"
import {checkIfCustomerStoryIn} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyAdditionalFunctions"
import {
	CategoryModuleType,
	CustomerStoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import CustomerPosts from "@jsons/customerStories.json"
import {useRouter} from "next/router"
import React from "react"

import styles from "./CustomerStoryPost.module.scss"

type Props = {
	article: string
	data: CustomerStoryModuleType
}

const CustomerStoryPost = (props: Props) => {
	const router = useRouter()

	const Stories = getPosts("CustomerStoriesModule", {data: CustomerPosts})

	const data = props.data
	const {changeLocale: changeLocaleCustome} = useLocale()
	changeLocaleCustome(props.data.lang)
	const categories = data.useCase.map(
		(element: CategoryModuleType, index: number) => {
			return element.slug
		},
	)

	let storiesData = Stories

	if (typeof storiesData !== "undefined") {
		storiesData = Stories.filter(
			(element: any) => element.slug !== data.slug,
		)
		const FilteredBlogData = checkIfCustomerStoryIn(storiesData, categories)

		if (FilteredBlogData.length > 0) {
			storiesData = FilteredBlogData

			if (FilteredBlogData.length === 1) {
				storiesData.push(
					Stories.filter(
						(element: any) =>
							element.slug !== data.slug &&
							element.slug !== storiesData[0].slug,
					)[0],
				)
			}
		}
	}

	const preview = data.inside.src ? data.inside : data.preview

	return (
		<>
			<ContainerWrapper style={{overflow: "hidden"}}>
				<Separator
					className={styles.post__container}
					type={"padding"}
					withoutMeasure
				>
					<Separator>
						<NewResponsiveImage
							imageClassName={styles.logo}
							withoutContainer
							{...props.data.logo}
						/>

						<Separator size={16} />
						<Typography
							className={styles.title}
							content={data.title}
							variant={Variant.SectionTitle}
						/>
						<Typography
							content={
								<>
									{data.useCase.map(
										(
											element: CategoryModuleType,
											index: number,
										) => {
											return (
												<React.Fragment key={index}>
													{translate(
														element.title,
														router.locale,
													)}
												</React.Fragment>
											)
										},
									)}
									{data.industry.map(
										(
											element: CategoryModuleType,
											index: number,
										) => {
											return (
												<React.Fragment key={index}>
													{" "}
													|{" "}
													{translate(
														element.title,
														router.locale,
													)}
												</React.Fragment>
											)
										},
									)}
								</>
							}
							size={Size.XS}
							fontWeight={300}
							variant={Variant.Paragraph}
							noPadding
						/>
					</Separator>

					{preview?.type === "video" && (
						<Separator
							className={styles.asset__container}
							size={16}
							type={"padding"}
							withoutMeasure
						>
							<Asset
								data={{
									...preview,
									alt: props?.data?.title ?? preview?.alt,
								}}
								type={preview.type}
							/>
						</Separator>
					)}

					<Separator
						className={styles.contentContainer}
						size={16}
						type={"padding"}
					>
						<Typography
							content={data.content}
							size={Size.XS}
							fontWeight={300}
							variant={Variant.Description}
							as={"div"}
							noPadding
						/>
					</Separator>
					<Separator />
				</Separator>
			</ContainerWrapper>

			<Separator className={styles.cardsBox} size={128}>
				<ContainerWrapper>
					<Typography
						content={translate(
							"More Customer Stories",
							router.locale,
						)}
						variant={Variant.SectionTitle}
					/>
					<Separator />
					{storiesData.length > 0 && (
						<Separator
							className={styles.cardContainer}
							type={"padding"}
							withoutMeasure
						>
							{storiesData.map((element: any, index: number) => {
								if (index < 2) {
									return (
										<CustomerStorySmallCard
											key={index}
											className={styles.cardBox}
											data={element}
										/>
									)
								}
								return undefined
							})}
						</Separator>
					)}
				</ContainerWrapper>
			</Separator>
		</>
	)
}

export default CustomerStoryPost
